import { OperationResult } from '@vp/common/core/OperationResult';
import { RemoveMediaDto } from '@vp/manager/gallery/core/dto/RemoveMediaDto';
import { UploadMediaDto } from '@vp/manager/gallery/core/dto/UploadMediaDto';
import { GalleryManagerUploadHandle } from '@vp/manager/gallery/core/interface/GalleryManagerUploadHandle';
import { ProfileLiveMediaModel } from '@vp/profile/core/model/ProfileLiveMediaModel';
import { ProfileModel } from '@vp/profile/core/model/ProfileModel';
import { ProfilePhotoModel } from '@vp/profile/core/model/ProfilePhotoModel';

export abstract class GalleryManagerRepository {
  abstract upload(dto: UploadMediaDto): GalleryManagerUploadHandle;
  abstract remove(dto: RemoveMediaDto, controller?: AbortController): Promise<OperationResult<ProfileModel>>;
  abstract makeLive(photoId: string, controller?: AbortController): Promise<OperationResult<[ProfilePhotoModel, ProfileLiveMediaModel]>>;
  abstract makeStatic(photoId: string, controller?: AbortController): Promise<OperationResult<[ProfilePhotoModel, ProfileLiveMediaModel]>>;
}
